import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=3997b52f&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3997b52f')) {
      api.createRecord('3997b52f', component.options)
    } else {
      api.reload('3997b52f', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=3997b52f&", function () {
      api.rerender('3997b52f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2BoBMEha5c6wo/JS/offershelp.vue"
export default component.exports